export default __webpack_public_path__ + "static/media/fb.519d2dac.svg";